import React from "react";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import Home from "./components/Home";
import PlanLists from "./components/PlanList";
import ThankyouPage from "./components/ThankyouPage";
import PrivacyAndPolicy from "./components/PrivacyPolicy";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/test-series" element={<PlanLists />} />
        <Route path="/thankyou-page" element={<ThankyouPage />} />
        <Route path="/privacypolicy" element={<PrivacyAndPolicy />} />
      </Routes>
    </Router>
  );
};

export default App;
